<template>
  <div class="Detail">
    <template v-for="det in detail.progresses" v-key="det.content.title">
      <my_content :content="det.content" :inputStyle="det.style"></my_content>
    </template>
    <detail_images :images="detail.images"></detail_images>
  </div>
</template>

<script>
 import MyContent from '@/components/Content.vue';
 import DetailImages from '@/components/frontpage/DetailImages.vue'
 export default {
   name: 'Detail',
   props: ['detail'],
   computed: {
   },
   components: {
     my_content: MyContent,
     detail_images: DetailImages
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Detail{
   height: 104.2vw;
   box-sizing: border-box;
   padding-top: 3vw;
   padding-bottom: 3vw;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: space-around;
 }
</style>
